export default "__VITE_ASSET__DZMdwmxy__"